import { get } from "lodash";
import {
	ProductKeys,
	ProductLegalDetailEnums,
	ProductLogo,
	ProductQuickStartConfig,
	ProductSupportEnums,
} from "../constants/product";

// eslint-disable-next-line @typescript-eslint/no-explicit-any -- deeply nested dynamic property access via ProductKeys requires any
export const FixProductListingData = (data: Record<string, any>) => {
	Object.keys(data).forEach((key) => {
		if (data[key]) {
			// Code to make convert nullable fields to empty string
			switch (key) {
				case ProductKeys.logo:
					if (!data[ProductKeys.logo][ProductLogo.url]) {
						data[ProductKeys.logo][ProductLogo.url] = "";
					}
					break;
				case ProductKeys.quickStartConfig:
					if (!data[ProductKeys.quickStartConfig][ProductQuickStartConfig.instructions]) {
						data[ProductKeys.quickStartConfig][ProductQuickStartConfig.instructions] = "";
					}
					if (
						!get(data, `${ProductKeys.quickStartConfig}.${ProductQuickStartConfig.defaultDeployInstructions}`) ===
						undefined
					) {
						data[ProductKeys.quickStartConfig][ProductQuickStartConfig.instructions] = true;
					}
					break;
				case ProductKeys.legal:
					if (!data[ProductKeys.legal][ProductLegalDetailEnums.licenseAgreementUrl]) {
						data[ProductKeys.legal][ProductLegalDetailEnums.licenseAgreementUrl] = "";
					}
					if (!data[ProductKeys.legal][ProductLegalDetailEnums.privacyPolicyUrl]) {
						data[ProductKeys.legal][ProductLegalDetailEnums.privacyPolicyUrl] = "";
					}
					break;
				case ProductKeys.support:
					if (!data[ProductKeys.support][ProductSupportEnums.description]) {
						data[ProductKeys.support][ProductSupportEnums.description] = "";
					}
					if (!data[ProductKeys.support][ProductSupportEnums.phoneNumber]) {
						data[ProductKeys.support][ProductSupportEnums.phoneNumber] = "";
					}
					if (!data[ProductKeys.support][ProductSupportEnums.emailAddress]) {
						data[ProductKeys.support][ProductSupportEnums.emailAddress] = "";
					}
					break;
				default:
					break;
			}
		}
	});
	data[ProductKeys.isPublished] = data[ProductKeys.isPublished] ? data[ProductKeys.isPublished] : false; // Default value to trigger validation
	return data;
};
